import React from 'react';
import logo from '../images/logo.png';

function Footer() {
  return (
    <footer id="footer">
    {/* <div className="footer-newsletter">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <h4>Join Our Newsletter</h4>
            <p>
              Tamen quem nulla quae legam multos aute sint culpa legam noster
              magna
            </p>
            <form action="" method="post">
              <input type="email" name="email" />
              <input type="submit" defaultValue="Subscribe" />
            </form>
          </div>
        </div>
      </div>
    </div> */}
    <div className="footer-top">
       <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-6 footer-contact">
            <img src={logo} alt="logo" className="img-fluid" style={{
              width:"60%",
              height:"auto",
              marginBottom:"10px"
            }} />
            <p>
              Address - 5-37-222 , SV Royal Building, <br/> 4th line Brodipet, Guntur,<br/> AP, India - 522002
              <br />
              <strong>Phone:</strong> +91-9492959926
              <br />
              <strong>Email:</strong> dcodeap@gmail.com
              <br />
            </p>
          </div>
          <div className="col-lg-3 col-md-6 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li>
                <i className="bx bx-chevron-right" /> <a href="#hero">Home</a>
              </li>
              <li>
                <i className="bx bx-chevron-right" /> <a href="#about">About us</a>
              </li>
              <li>
                <i className="bx bx-chevron-right" /> <a href="#services">Services</a>
              </li>
              <li>
                <i className="bx bx-chevron-right" />{" "}
                <a href="#">Terms of service</a>
              </li>
              <li>
                <i className="bx bx-chevron-right" />{" "}
                <a href="#">Privacy policy</a>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 col-md-6 footer-links">
            <h4>Our Services</h4>
            <ul>
              <li>
                <i className="bx bx-chevron-right" />{" "}
                <a href="#services">Web Development</a>
              </li>
              <li>
                <i className="bx bx-chevron-right" />{" "}
                <a href="#services">Digital Marketing</a>
              </li>
              <li>
                <i className="bx bx-chevron-right" /> <a href="#services">Internship and Projects</a>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 col-md-6 footer-links">
            <h4>Our Social Networks</h4>
            <p>
              Follow us on social media for latest updates and special offers
            </p>
            <div className="social-links mt-3">
              <a href="https://twitter.com/DcodeSystems" className="twitter">
                <i className="bx bxl-twitter" />
              </a>
              <a href="https://www.linkedin.com/company/dcode-systems" className="linkedin">
                <i className="bx bxl-linkedin" />
              </a>
              <a href="https://whatsapp.com/channel/0029VaP7aD8Chq6R4Ut2JG0e" className="whatsapp">
                <i className="bx bxl-whatsapp" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="container py-4 ">
      <div className="copyright">
        © 2024 Copyright{" "}
        <strong>
          <span>Dcode Systems</span>
        </strong>
        . All Rights Reserved
      </div>
    </div>
  </footer>
  )
}

export default Footer
